<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import Chart from '@/components/charts/Chart'

export default {
  name: 'AmcEcUserAnalysisSalesChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    },
    labelField: {
      type: String,
      default: 'month'
    },
    categoryNo: {
      type: Number,
      default: 1
    },
  },
  computed: {
    chartData () {
      const target = this.report[this.categoryNo - 1]
      let keys = []
      target.forEach(obj => {
        keys.push(...Object.keys(obj))
      })
      const s = new Set(keys)
      s.delete('month')
      keys = Array.from(s)

      const datasets = []
      keys.forEach(key => {
        if (key === '未分類') {
          datasets.push({
            label: '未分類',
            data: target.map(item => item['未分類']),
            backgroundColor: '#B7B7B7',
            yAxisID: 'barChart'
          })
        } else {
          datasets.unshift(
            {
              label: key,
              data: target.map(item => item[key]),
              yAxisID: 'barChart'
            }
          )
        }
      });
      return {
        labels: target.map(item => item[this.labelField]),
        datasets: datasets
      }
    },
    options () {
      return {
        plugins: {
          legend: {
            display: true,
            reverse: false
          },
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                return `${label}: \xA5${value}`
              }
            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true
          },
          barChart: {
            stacked: true,
            ticks: {
              callback (value) {
                return `\xA5${value.toLocaleString()}`
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
